import { css } from "@emotion/react";

export const fontKrub = () => css`
  font-family: "Krub", sans-serif;
  font-weight: 300;
`;

export const fontQuicksand = () => css`
  font-family: "Quicksand", sans-serif;
  font-weight: 500;
`;
